import useLangText from '@shared/hooks/useLangText';
import {
    ProcessFieldBase,
    type ProcessFieldSelect as ProcessFieldSelectType,
} from '@shared/types/process';
import { DefaultOptionType } from '@shared/types/types';

import { ShadcnForm } from '@shadcn-features/core';
import { ShadcnFormSelectProps } from '@shadcn-features/core/ShadcnForm/fields';
import { useMemo } from 'react';

interface Props extends Omit<ShadcnFormSelectProps, 'mode'> {
    field: ProcessFieldBase & ProcessFieldSelectType;
}

export function ProcessFieldSelectField({
    field,
    fieldProps,
    ...props
}: Props) {
    const getLangText = useLangText();

    const options: DefaultOptionType[] = useMemo(() => {
        return field?.options?.options?.map((item) => {
            return {
                label: getLangText(item.label),
                value: item.value,
            };
        }) as DefaultOptionType[];
    }, [field?.options?.options, getLangText]);

    if (field?.options.mode === 'multiple') {
        return (
            <ShadcnForm.MultiSelect
                allowClear
                mode='multiple'
                options={options}
                fieldProps={{
                    ...fieldProps,
                    maxCount: field?.options.maxCount
                        ? Number(field?.options.maxCount)
                        : undefined,
                }}
                {...props}
                tooltip={getLangText(field?.tooltip ?? '')}
            />
        );
    }

    return (
        <ShadcnForm.Select
            allowClear
            options={options}
            fieldProps={{
                ...fieldProps,
            }}
            {...props}
            tooltip={getLangText(field?.tooltip ?? '')}
        ></ShadcnForm.Select>
    );
}
